import { List } from 'immutable'
import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  loaded: false,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setUserPayoutProfiles = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: List(state.data).concat(List(payload.data)).toJS(),
    loading: false,
    loaded: true,
  })

const setPayoutProfilesFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropPayoutProfilesList = (state) =>
  updateObject(state, {
    data: [],
    loaded: false,
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER/USER_PAYOUT_PROFILES_SET_LOADING':
      return setLoading(state, action)
    case 'USER/SET_USER_PAYOUT_PROFILES':
      return setUserPayoutProfiles(state, action)
    case 'USER/PAYOUT_PROFILES_SET_FILTER':
      return setPayoutProfilesFilter(state, action)
    case 'USER/DROP_USER_PAYOUT_PROFILES':
      return dropPayoutProfilesList(state, action)
    default:
      return state
  }
}

export default reducer
